<div class="modal left fadeInUp bg-color2" (click)="CloseMenu()" style="display: block;bottom:42px" id="leftmenu2">


</div>
<div [@fadeInOut] class="model-menu bg-color" style="display: block;bottom: 0px;">
  <div class="model-m-body" style="margin-top: 00px;">
    <aside class="sidebar2 row">

      <div class="col-md-12 p-0">
        <div class="col-md-12 blue-seprator1">
          <img src="assets/images/iAR.png" class="img-responsive">
          <div class="middle-align1">
            <div class="col-md-12 p-0">
              <span class="u-name">{{UserData.Full_Name}}</span>
            </div>
            <div class="col-md-12 p-0">
              <span class="u-type">{{UserData.Role}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 p-0 mt-10">
        <div class="m-leftsidebar bdr-t pt-0" style="margin-top: 2%;">
          <div class="menu">
            <div *ngIf="UserData.Role!='Client User' && UserData.Role!='Client Supervisor'"
              class="panel-group menu-small" id="accordionMenu" role="tablist" aria-multiselectable="true">

              <div *ngIf="checkMenu('user-menu-mapping')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingClientUserMappingManagement">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('user-menu-mapping')"
                      [ngClass]="[MenuName == roleName+'/user-menu-mapping' ? 'menu-active1': '' ]">
                      User Menu Mapping
                    </a>
                  </h4>
                </div>
              </div>
              <div *ngIf="checkMenu('client-user-mapping-management')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingClientUserMappingManagement">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-user-mapping-management')"
                      [ngClass]="[MenuName == roleName+'/client-user-mapping-management' ? 'menu-active1': '' ]">
                      Client User Mapping Management
                    </a>
                  </h4>
                </div>
              </div>

              <!-- <div *ngIf="checkMenu('productivity-report')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingProductivity">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('productivity-report')"
                      [ngClass]="[MenuName == roleName+'/productivity-report' ? 'menu-active1': '' ]">
                      Productivity Report
                    </a>
                  </h4>
                </div>
              </div> -->
              <!-- <div *ngIf="checkMenu('agent-productivity-report')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingAgentProductivity">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('agent-productivity-report')"
                      [ngClass]="[MenuName == roleName+'/agent-productivity-report' ? 'menu-active1': '' ]">
                      Agent Productivity Report
                    </a>
                  </h4>
                </div>
              </div> -->
              <div *ngIf="checkMenu('client-configuration')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-configuration')"
                      [ngClass]="[MenuName == roleName+'/client-configuration' ? 'menu-active1': '' ]">
                      Client Configuration
                    </a>
                  </h4>
                </div>
              </div>
              <!-- <div *ngIf="checkMenu('citra-employee-mapping')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('citra-employee-mapping')"
                      [ngClass]="[MenuName == roleName+'/citra-employee-mapping' ? 'menu-active1': '' ]">
                      Citra Employee Mapping
                    </a>
                  </h4>
                </div>
              </div> -->

              <div *ngIf="checkMenu('user-management')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingtwo">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('user-management')"
                      [ngClass]="[MenuName == roleName+'/user-management' ? 'menu-active1': '']">
                      User Management
                    </a>
                  </h4>
                </div>
              </div>



              <!-- <div *ngIf="checkMenu('global-insurance') || checkMenu('global-mapping')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingFour">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/global-insurance' || MenuName == roleName+'/global-insurance' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" aria-controls="collapseOne"
                      href="#collapseOne"
                      [attr.aria-expanded]="[MenuName == roleName+'/global-insurance' || MenuName == roleName+'/global-mapping' ? 'true' : 'false']">
                      Manage Insurance
                    </a>
                  </h4>
                </div>
                <div id="collapseOne"
                  [attr.aria-expanded]="[MenuName == roleName+'/global-insurance' || MenuName == roleName+'/global-mapping' ? 'true' : 'false']"
                  class="panel-collapse collapse"
                  [ngClass]="[MenuName == roleName+'/global-insurance' || MenuName == roleName+'/global-mapping' ? 'in' : '']"
                  role="tabpanel" aria-labelledby="headingOne">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li>
                        <a (click)="OpenMenu('global-insurance')"
                          [ngClass]="[MenuName == roleName+'/global-insurance' ? 'menu-active1': '']">
                          Global Insurance</a>
                      </li>
                      <li>
                        <a (click)="OpenMenu('global-mapping')"
                          [ngClass]="[ MenuName == roleName+'/global-mapping' ? 'menu-active1': '']">Global
                          Insurance Mapping</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
              <div *ngIf="checkMenu('auto-allocation')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingFive">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('auto-allocation')"
                      [ngClass]="[ MenuName == roleName+'/auto-allocation' ? 'menu-active1': '']">
                      Auto-Q Configuration
                    </a>
                  </h4>
                </div>
              </div>
               <div *ngIf="checkMenu('bucket-mapping')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingSix">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('bucket-mapping')"
                      [ngClass]="[MenuName == roleName+'/bucket-mapping' ? 'menu-active1': '']">
                      AR Skills Mapping
                    </a>
                  </h4>
                </div>
              </div>
              <div *ngIf="checkMenu('data-upload')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingSeven">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('data-upload')"
                      [ngClass]="[MenuName == roleName+'/data-upload' ? 'menu-active1': '']">
                      Data Upload
                    </a>
                  </h4>
                </div>
              </div>

              <div
                *ngIf="checkMenu('supervisor-agent') || checkMenu('agent-deallocation') || checkMenu('de-allocation')"
                class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingEight">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/supervisor-agent'|| MenuName == roleName+'/agent-deallocation'  || MenuName == roleName+'/de-allocation' || MenuName == roleName+'/agent-reallocation' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" href="#collapseThree"
                      [attr.aria-expanded]="[MenuName == roleName+'/supervisor-agent'|| MenuName == roleName+'/agent-deallocation' || MenuName == roleName+'/de-allocation' || MenuName == roleName+'/agent-reallocation' ? 'true' : 'false']"
                      aria-controls="collapseThree">
                      Supervisor
                    </a>
                  </h4>
                </div>

                <div id="collapseThree"
                  [attr.aria-expanded]="[MenuName == roleName+'/supervisor-agent' || MenuName == roleName+'/agent-deallocation' || MenuName == roleName+'/de-allocation' || MenuName == roleName+'/agent-reallocation' ? 'true' : 'false']"
                  class="panel-collapse collapse"
                  [ngClass]="[MenuName == roleName+'/supervisor-agent'|| MenuName == roleName+'/agent-deallocation' || MenuName == roleName+'/de-allocation' || MenuName == roleName+'/agent-reallocation' ? 'in' : '']"
                  role="tabpanel" aria-labelledby="headingThree">
                  <div class="accordianbody">
                    <ul class="nav">

                      <li><a role="button" (click)="OpenMenu('supervisor-dashboard')"
                          [ngClass]="[MenuName == roleName+'/supervisor-dashboard' ? 'menu-active1': '']">Dashboard</a>
                      </li>

                      <li><a role="button" (click)="OpenMenu('supervisor-agent')"
                          [ngClass]="[MenuName == roleName+'/supervisor-agent' ? 'menu-active1': '']">
                          Edit Record</a></li>

                      <!-- <li><a role="button" (click)="OpenMenu('de-allocation')"
                          [ngClass]="[MenuName == roleName+'/de-allocation' ? 'menu-active1': '']">De-allocation</a>
                      </li> -->

                      <li><a role="button" (click)="OpenMenu('agent-deallocation')"
                          [ngClass]="[MenuName == roleName+'/agent-deallocation' ? 'menu-active1': '']">Agent
                          Deallocation</a>
                      </li>

                      <li><a role="button" (click)="OpenMenu('agent-reallocation')"
                          [ngClass]="[MenuName == roleName+'/agent-reallocation' ? 'menu-active1': '']">Agent
                          Reallocation</a>
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
              <div *ngIf="checkMenu('agent')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingNine">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('agent')"
                      [ngClass]="[MenuName == roleName+'/agent' ? 'menu-active1': '']">
                      Agent
                    </a>
                  </h4>
                </div>
              </div>

              <div
                *ngIf="checkMenu('simple-report') || checkMenu('mis-report') || checkMenu('citra-audit-report') || checkMenu('client-simple-report')"
                class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingTen">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/simple-report' || MenuName == roleName+'/mis-report' || MenuName == roleName+'/tl-deny-report' || MenuName == roleName+'/citra-audit-report' || MenuName == roleName+'/client-simple-report' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" aria-controls="collapseThree"
                      href="#collapseReport"
                      [attr.aria-expanded]="[MenuName == roleName+'/simple-report' || MenuName == roleName+'/mis-report' || MenuName == roleName+'/tl-deny-report' || MenuName == roleName+'/citra-audit-report' || MenuName == roleName+'/client-simple-report'? 'true' : 'false']">
                      Reports
                    </a>
                  </h4>
                </div>
                <div id="collapseReport"
                  [attr.aria-expanded]="[MenuName == roleName+'/simple-report' || MenuName == roleName+'/mis-report' || MenuName == roleName+'/tl-deny-report'|| MenuName == roleName+'/ageing-dashboard-report' || MenuName == roleName+'/citra-audit-report' || MenuName == roleName+'/client-simple-report'? 'true' : 'false']"
                  class="panel-collapse collapse"
                  [ngClass]="[MenuName == roleName+'/simple-report' || MenuName == roleName+'/mis-report'  || MenuName == roleName+'/tl-deny-report' || MenuName == roleName+'/ageing-dashboard-report' || MenuName == roleName+'/citra-audit-report' || MenuName == roleName+'/client-simple-report' ? 'in' : '']"
                  role="tabpanel" aria-labelledby="headingReport">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li><a (click)="OpenMenu('simple-report')"
                          [ngClass]="[MenuName == roleName+'/simple-report' ? 'menu-active1': '']">Simple Report</a>
                      </li>
                      <li *ngIf="checkMenu('client-simple-report')"><a (click)="OpenMenu('client-simple-report')"
                          [ngClass]="[MenuName == roleName+'/client-simple-report' ? 'menu-active1': '']">Client Simple
                          Report</a></li>
                      <!-- <li><a (click)="OpenMenu('mis-report')"
                          [ngClass]="[MenuName == roleName+'/mis-report' ? 'menu-active1': '']">Time Management</a></li> -->

                      <!-- <li><a (click)="OpenMenu('tms-report')"
                        [ngClass]="[MenuName == roleName+'/tms-report' ? 'menu-active1': '']">TMS Report</a></li> -->

                      <li><a (click)="OpenMenu('unworked-accounts-report')"
                          [ngClass]="[MenuName == roleName+'/unworked-accounts-report' ? 'menu-active1': '']">Unworked
                          Allocation
                          A/C Report</a></li>
                      <!-- <li><a (click)="OpenMenu('production-report')"
                          [ngClass]="[MenuName == roleName+'/production-report' ? 'menu-active1': '']">Production
                          Report</a></li> -->
                      <li *ngIf="checkMenu('tl-deny-report')"><a (click)="OpenMenu('tl-deny-report')"
                          [ngClass]="[MenuName == roleName+'/tl-deny-report' ? 'menu-active1': '']">Deny Report</a></li>

                      <!-- <li *ngIf="checkMenu('ageing-dashboard-report')"><a (click)="OpenMenu('ageing-dashboard-report')"
                          [ngClass]="[MenuName == roleName+'/ageing-dashboard-report' ? 'menu-active1': '']">Ageing
                          Dashboard
                          Report</a></li> -->
                      <!-- <li><a (click)="OpenMenu('citra-audit-report')"
                          [ngClass]="[MenuName == roleName+'/citra-audit-report' ? 'menu-active1': '']">Citra Audit
                          Report</a>
                      </li> -->
                      <!-- <li><a (click)="OpenMenu('ciinra-audit-report')"
                          [ngClass]="[MenuName == roleName+'/ciinra-audit-report' ? 'menu-active1': '']">CiiNRA Audit
                          Report</a>
                      </li> -->
                      <!-- <li><a (click)="OpenMenu('pcn-report')"
                          [ngClass]="[MenuName == roleName+'/pcn-report' ? 'menu-active1': '']">PCN Report</a>
                      </li> -->
                      <!-- <li><a (click)="OpenMenu('RFFIndexing-report')"
                          [ngClass]="[MenuName == roleName+'/RFFIndexing-report' ? 'menu-active1': '']">EOB Route
                          Management
                          Report</a>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="checkMenu('agent-eob-rff')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('agent-eob-rff')"
                      [ngClass]="[MenuName == roleName+'/agent-eob-rff' ? 'menu-active1': '']">
                      EOB Route Management
                    </a>
                  </h4>
                </div>
              </div> -->

              <div *ngIf="checkMenu('upload-file') || checkMenu('view-file')" class="panel panel-default">
                <!-- <div class="acc-heading" role="tab" id="headingThree">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/upload-file' || MenuName == roleName+'/view-file' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" href="#collapseFile"
                      aria-controls="collapseThree"
                      [attr.aria-expanded]="[MenuName == roleName+'/upload-file' || MenuName == roleName+'/view-file' ? 'true' : 'false']">
                      AR KMS
                    </a>
                  </h4>
                </div> -->
                <div
                  [attr.aria-expanded]="[MenuName == roleName+'/upload-file' || MenuName == roleName+'/view-file' ? 'true' : 'false']"
                  id="collapseFile"
                  [ngClass]="[MenuName == roleName+'/upload-file' || MenuName == roleName+'/view-file' ? 'in' : '']"
                  class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFile">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li *ngIf="checkMenu('upload-file')"><a (click)="OpenMenu('upload-file')"
                          [ngClass]="[MenuName == roleName+'/upload-file' ? 'menu-active1': '']">Upload AR KMS</a></li>
                      <li *ngIf="checkMenu('view-file')"><a (click)="OpenMenu('view-file')"
                          [ngClass]="[MenuName == roleName+'/view-file' ? 'menu-active1': '']">View AR KMS</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div *ngIf="checkMenu('client-instruction')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-instruction')"
                      [ngClass]="[MenuName == roleName+'/client-instruction' ? 'menu-active1': '']">
                      Client Instruction
                    </a>
                  </h4>
                </div>
              </div>
              <!-- project and priority -->
              <!-- <div *ngIf="checkMenu('project-and-priority') || checkMenu('deallocate-module')"
                class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingThree">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/project-and-priority' || MenuName == roleName+'/deallocate-module' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu"
                      href="#collapseFileProjectAndPriority" aria-controls="collapseThree"
                      [attr.aria-expanded]="[MenuName == roleName+'/project-and-priority' || MenuName == roleName+'/deallocate-module' ? 'true' : 'false']">
                      Project & Priority
                    </a>
                  </h4>
                </div>
                <div
                  [attr.aria-expanded]="[MenuName == roleName+'/project-and-priority' || MenuName == roleName+'/deallocate-module' ? 'true' : 'false']"
                  id="collapseFileProjectAndPriority"
                  [ngClass]="[MenuName == roleName+'/project-and-priority' || MenuName == roleName+'/deallocate-module' ? 'in' : '']"
                  class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFile">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li *ngIf="checkMenu('project-and-priority-dashboard')"><a
                          (click)="OpenMenu('project-and-priority-dashboard')"
                          [ngClass]="[MenuName == roleName+'/project-and-priority-dashboard' ? 'menu-active1': '']">
                          P&P Dashboard</a>
                      </li>
                      <li *ngIf="checkMenu('deallocate-module')"><a (click)="OpenMenu('deallocate-module')"
                          [ngClass]="[MenuName == roleName+'/deallocate-module' ? 'menu-active1': '']">
                          De-Allocate Module</a>
                      </li>
                      <li *ngIf="checkMenu('project-and-priority-report')"><a
                          (click)="OpenMenu('project-and-priority-report')"
                          [ngClass]="[MenuName == roleName+'/project-and-priority-report' ? 'menu-active1': '']">
                          P&P Report</a>
                      </li>

                    </ul>
                  </div>
                </div>
              </div> -->

              <!-- Start Added CARC & RARC Master Menu -->
              <!-- <div *ngIf="checkMenu('carc-rarc-master')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('carc-rarc-master')"
                      [ngClass]="[MenuName == roleName+'/carc-rarc-master' ? 'menu-active1': '']">
                      CARC & RARC Master
                    </a>
                  </h4>
                </div>
              </div> -->
              <!-- End Added CARC & RARC Master Menu -->

              <!-- <div
                *ngIf="checkMenu('concluder-dashboard') || checkMenu('concluder-report') || checkMenu('concluder-master-update')"
                class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingThree">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/concluder-dashboard' || MenuName == roleName+'/concluder-report' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" href="#collapseFileConcluder"
                      aria-controls="collapseThree"
                      [attr.aria-expanded]="[MenuName == roleName+'/concluder-dashboard' || MenuName == roleName+'/concluder-report' ? 'true' : 'false']">
                      Concluder
                    </a>
                  </h4>
                </div>
                <div
                  [attr.aria-expanded]="[MenuName == roleName+'/concluder-dashboard' || MenuName == roleName+'/concluder-report' || MenuName == roleName+'/concluder-deallocation' ? 'true' : 'false']"
                  id="collapseFileConcluder"
                  [ngClass]="[MenuName == roleName+'/concluder-dashboard' || MenuName == roleName+'/concluder-report' || MenuName == roleName+'/concluder-deallocation' ? 'in' : '']"
                  class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFile">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li *ngIf="checkMenu('concluder-dashboard')"><a (click)="OpenMenu('concluder-dashboard')"
                          [ngClass]="[MenuName == roleName+'/concluder-dashboard' ? 'menu-active1': '']">
                          Concluder Dashboard</a>
                      </li>
                      <li *ngIf="checkMenu('concluder-report')"><a (click)="OpenMenu('concluder-report')"
                          [ngClass]="[MenuName == roleName+'/concluder-report' ? 'menu-active1': '']">
                          Concluder Report</a>
                      </li>
                      <li *ngIf="checkMenu('concluder-deallocation')"><a (click)="OpenMenu('concluder-deallocation')"
                          [ngClass]="[MenuName == roleName+'/concluder-deallocation' ? 'menu-active1': '']">
                          De-Allocate Concluder</a>
                      </li>
                      <li *ngIf="checkMenu('supervisor-inbox-mapping')"><a
                          (click)="OpenMenu('supervisor-inbox-mapping')"
                          [ngClass]="[MenuName == roleName+'/supervisor-inbox-mapping' ? 'menu-active1': '']">
                          Concluder Inbox Mapping</a>
                      </li>

                      <li *ngIf="checkMenu('concluder-master-update')"><a (click)="OpenMenu('concluder-master-update')"
                          [ngClass]="[MenuName == roleName+'/concluder-master-update' ? 'menu-active1': '']">
                          Concluder Master Update</a>
                      </li>

                    </ul>
                  </div>
                </div>
              </div> -->

              <div *ngIf="checkMenu('client-instruction-report') || checkMenu('client-dashboard-report')"
                class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingThree">
                  <h4 class="acc-title">
                    <a [ngClass]="[MenuName == roleName+'/client-instruction-report' || MenuName == roleName+'/client-dashboard-report' ? '' : 'collapsed']"
                      role="button" data-toggle="collapse" data-parent="#accordionMenu" href="#collapseFile"
                      aria-controls="collapseThree"
                      [attr.aria-expanded]="[MenuName == roleName+'/client-instruction-report' || MenuName == roleName+'/client-dashboard-report' ? 'true' : 'false']">
                      Reports
                    </a>
                  </h4>
                </div>
                <div
                  [attr.aria-expanded]="[MenuName == roleName+'/client-instruction-report' || MenuName == roleName+'/client-dashboard-report' ? 'true' : 'false']"
                  id="collapseFile"
                  [ngClass]="[MenuName == roleName+'/client-instruction-report' || MenuName == roleName+'/client-dashboard-report' ? 'in' : '']"
                  class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFile">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li *ngIf="checkMenu('client-instruction-report')"><a
                          (click)="OpenMenu('client-instruction-report')"
                          [ngClass]="[MenuName == roleName+'/client-instruction-report' ? 'menu-active1': '']">
                          Client Instruction
                          Report</a>
                      </li>
                      <li *ngIf="checkMenu('client-dashboard-report')"><a (click)="OpenMenu('client-dashboard-report')"
                          [ngClass]="[MenuName == roleName+'/client-dashboard-report' ? 'menu-active1': '']">Client
                          Dashboard
                          Report</a>
                      </li>
                      <!-- <li *ngIf="checkMenu('ageing-dashboard-report')"><a (click)="OpenMenu('ageing-dashboard-report')"
                          [ngClass]="[MenuName == roleName+'/ageing-dashboard-report' ? 'menu-active1': '']">Ageing
                          Dashboard
                          Report</a></li> -->

                    </ul>
                  </div>
                </div>
              </div>
              <div *ngIf="checkMenu('client-approval')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-approval')"
                      [ngClass]="[MenuName == roleName+'/client-approval' ? 'menu-active1': '']">
                      Exceptions
                    </a>
                  </h4>
                </div>
              </div>

              <div *ngIf="checkMenu('client-user')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-user')"
                      [ngClass]="[MenuName == roleName+'/client-user' ? 'menu-active1': '']">
                      Exceptions
                    </a>
                  </h4>
                </div>
              </div>

              <div *ngIf="checkMenu('client-assistance')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-assistance')"
                      [ngClass]="[MenuName == roleName+'/client-assistance' ? 'menu-active1': '']">
                      Stuck Money Manager
                    </a>
                  </h4>
                </div>
              </div>

              <!-- <div *ngIf="checkMenu('denial-code')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('denial-code')"
                      [ngClass]="[MenuName == roleName+'/denial-code' ? 'menu-active1': '']">
                      Denial Code
                    </a>
                  </h4>
                </div>
              </div> -->

              <div *ngIf="checkMenu('standard-comment')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('standard-comment')"
                      [ngClass]="[MenuName == roleName+'/standard-comment' ? 'menu-active1': '']">
                      Standard Comment
                    </a>
                  </h4>
                </div>
              </div>


              <div *ngIf="checkMenu('agent-correspondence')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('agent-correspondence')"
                      [ngClass]="[MenuName == roleName+'/agent-correspondence' ? 'menu-active1': '']">
                      Correspondence Entry
                    </a>
                  </h4>
                </div>
              </div>


              <div *ngIf="checkMenu('exception-entry')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('exception-entry')"
                      [ngClass]="[MenuName == roleName+'/exception-entry' ? 'menu-active1': '']">
                      Add New Exception
                    </a>
                  </h4>
                </div>
              </div>
              <div *ngIf="checkMenu('bi-report')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingEight">
                  <h4 class="acc-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordionMenu"
                      href="#collapseThree_1" aria-expanded="false" aria-controls="collapseThree">
                      Analytics
                    </a>
                  </h4>
                </div>
                <div id="collapseThree_1" class="panel-collapse collapse" role="tabpanel"
                  aria-labelledby="headingThree">
                  <div class="accordianbody">
                    <ul class="nav">
                      <li *ngFor="let menu of biReportMenu">
                        <a role="button" (click)="openBIReport(menu)">
                          {{menu.Menu_Name}}
                        </a>
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
              <div *ngIf="checkMenu('bcbs-data-upload')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('bcbs-data-upload')"
                      [ngClass]="[MenuName == roleName+'/bcbs-data-upload' ? 'menu-active1': '']">
                      Upload BCBS Assistance
                    </a>
                  </h4>
                </div>
              </div>

              <!-- <div *ngIf="checkMenu('citra-audit')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('citra-audit')"
                      [ngClass]="[MenuName == roleName+'/citra-audit' ? 'menu-active1': '']">
                      Citra Audits
                    </a>
                  </h4>
                </div>
              </div> -->

              <!-- <div *ngIf="checkMenu('ciinra-audit')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('ciinra-audit')"
                      [ngClass]="[MenuName == roleName+'/ciinra-audit' ? 'menu-active1': '']">
                      CiiNRA Audits
                    </a>
                  </h4>
                </div>
              </div> -->

              <div *ngIf="checkMenu('contact-support')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingthree">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('contact-support')"
                    [ngClass]="[MenuName == roleName+'/contact-support' ? 'menu-active1': '']">
                      Contact Support
                    </a>
                  </h4>
                </div>
              </div>


              <div class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingthree">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('change-password')"
                      [ngClass]="[MenuName == '/change-password' ? 'menu-active1': '']">
                      Reset Password
                    </a>
                  </h4>
                </div>
              </div>
              <div class="panel panel-default" [ngClass]="{'disableDiv': btndis}">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="Logout()">
                      Logout
                    </a>
                  </h4>
                </div>
              </div>

            </div>
            <!-- Dynamic menus for Client User and Client Supervisor -->
            <!-- Dynamic menus for Client User and Client Supervisor -->
            <div *ngIf="UserData.Role=='Client User' || UserData.Role=='Client Supervisor'"
              class="panel-group menu-small" role="tablist" aria-multiselectable="true">
              <ng-container *ngFor="let menu of clientUserMenuList;let index=index">
                <div id="accordionMenuNormal"
                  *ngIf="menu.subMenus.length==0 &&  checkMenu(menu.Route) || checkMenu(menu.Route)"
                  class="panel panel-default">
                  <div class="acc-heading" role="tab" id="menu{{index}}">
                    <h4 class="acc-title">
                      <a style="text-transform: capitalize" *ngIf="menu.subMenus==null || menu.subMenus.length==0"
                        role="button" (click)="OpenMenu(menu.Route)"
                        [ngClass]="[matchedMenu(menu.subMenus) ? 'menu-active1': '']">
                        {{menu.Menu_Name}}
                      </a>
                    </h4>
                  </div>
                </div>
                <div id="accordionMenu" *ngIf="menu && menu.subMenus && menu.subMenus.length>0;let menuIndex=index"
                  class="panel panel-default">
                  <div class="acc-heading" role="tab" id="heading{{menuIndex}}">
                    <h4 class="acc-title">
                      <a [ngClass]="[matchedMenu(menu.subMenus) ? 'open' : 'collapsed']" role="button"
                        data-toggle="collapse" data-parent="#accordionMenu" aria-controls="collapseThree"
                        href="#collapseReport{{index}}"
                        [attr.aria-expanded]="[matchedMenu(menu.subMenus) ? 'true' : 'false']">
                        {{menu.Menu_Name}}
                      </a>
                    </h4>
                  </div>
                  <div id="collapseReport{{index}}"
                    [attr.aria-expanded]="[matchedMenu(menu.subMenus) ? 'true' : 'false']"
                    class="panel-collapse collapse"
                    [attr.aria-expanded]="[matchedMenu(menu.subMenus) ? 'true' : 'false']" role="tabpanel"
                    aria-labelledby="headingReport">
                    <div class="accordianbody">
                      <ul class="nav">
                        <ng-container *ngFor="let subMenu of menu.subMenus">
                          <li style="text-transform: capitalize;" *ngIf="checkMenu(subMenu.Route)">
                            <a (click)="openDynamicMenu(subMenu)"
                              [ngClass]="[MenuName == '/'+subMenu.Route ? 'menu-active1': '']">
                              {{subMenu.Submenu_Name}}
                            </a>
                          </li>
                        </ng-container>

                      </ul>
                    </div>
                  </div>
                </div>

              </ng-container>



              <!-- vinay bolli 12/1/2023 added below menu for account history -->

              <div *ngIf="checkMenu('client-account-history')" class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('client-account-history')"
                      [ngClass]="[MenuName == roleName+'/client-account-history' ? 'menu-active1': '']">
                      Account History
                    </a>
                  </h4>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="acc-heading" role="tab" id="headingthree">
                  <h4 class="acc-title">
                    <a role="button" (click)="OpenMenu('change-password')"
                      [ngClass]="[MenuName == roleName+'/change-password' ? 'menu-active1': '']">
                      Reset Password
                    </a>
                  </h4>
                </div>
              </div>
              <div class="panel panel-default" [ngClass]="{'disableDiv': btndis}">
                <div class="acc-heading" role="tab" id="headingOne">
                  <h4 class="acc-title">
                    <a role="button" (click)="Logout()">
                      Logout
                    </a>
                  </h4>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>



    </aside>
  </div>
</div>
